import React, { useState, useEffect } from "react";
import { ReactFlowProvider } from "reactflow";
import AgentView, { getHighlightNodeId, getHighlightNodeIdForSubAgentTool } from "./AgentView";
import "./index.css";
import SectionHeading from "../section-heading";
import { MdVisibilityOff } from "react-icons/md";
import { LuBot } from "react-icons/lu";

export default function AgentMonitor({ promptConfig, tools, agentEvents, onHide }) {
  const [highlightedNodeId, setHighlightedNodeId] = useState(null);

  const latestEvent = agentEvents.length > 0 ? agentEvents[agentEvents.length - 1] : null;

  useEffect(() => {
    if (!latestEvent) {
      setHighlightedNodeId(null);
      return;
    }

    let nodeId = getHighlightNodeId(latestEvent);

    if (!nodeId && latestEvent.isSubAgent && tools) {
      nodeId = getHighlightNodeIdForSubAgentTool(latestEvent, tools);
    }

    setHighlightedNodeId(nodeId);
  }, [latestEvent, tools]);

  return (
    <div className="flex h-full min-w-0 flex-1 flex-col">
      <SectionHeading title="Agent View" subtitle="Agent and connected tools" icon={LuBot}>
        {onHide && <button type="button" aria-label="Hide Agent View" aria-expanded={true} aria-controls="debugger-agent-view" onClick={onHide}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-gray-200 px-2.5 py-1.5 text-xs font-medium text-gray-600 transition hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500">
          <MdVisibilityOff size={15} aria-hidden="true" /> Hide
        </button>}
      </SectionHeading>
      <div className="min-h-0 flex-1 bg-gray-50/60">
        <ReactFlowProvider>
          <AgentView
            promptConfig={promptConfig}
            tools={tools || []}
            highlightedNodeId={highlightedNodeId}
          />
        </ReactFlowProvider>
      </div>
    </div>
  );
}
